import { Flex, Typography } from "antd";
import { ReactNode } from "react";

interface PageHeadingProps {
  title: ReactNode;
  /** Optional right-aligned content (actions). */
  extra?: ReactNode;
}

const PageHeading = ({ title, extra }: PageHeadingProps) => (
  <Flex
    align="center"
    justify="space-between"
    gap={16}
    wrap="wrap"
    style={{ background: "transparent", padding: "20px 0 16px" }}
  >
    <Typography.Title level={3} style={{ margin: 0 }}>
      {title}
    </Typography.Title>
    {extra}
  </Flex>
);

export default PageHeading;
